import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TtcButtonSharedModule } from '@libs/src/ttc-button-shared/ttc-button-shared.module';

import { GroupUpdateGoalsPromptComponent } from '@main-client/src/app/group-update-goals-prompt/group-update-goals-prompt.component';

@NgModule({
  imports: [CommonModule, RouterModule, TtcButtonSharedModule],
  declarations: [GroupUpdateGoalsPromptComponent],
  exports: [GroupUpdateGoalsPromptComponent],
})
export class GroupUpdateGoalsPromptModule {}
